const body = document.getElementsByTagName('body')[0];
const html = document.getElementsByTagName('html')[0];
const main = document.querySelector('main');
const burger = document.querySelector('.js-menu-btn');
const header = document.querySelector('.header');
const headerMenu = document.querySelector('.header__menu');
const headerNav = document.querySelector('.header__nav');
const headerLink = document.querySelectorAll('.header__nav-link');
const headerLogo = document.querySelector('.header__logo');
const search = document.querySelector('.header__search');
const searchBtn = document.querySelector('.js-search-btn');
const searchBtnClose = document.querySelector('.js-search-btn-close');
const searchTargetWrapper = document.querySelector('.header__search-child-absolute');
const searchTarget = document.querySelector('.js-search-target');
const searchInput = document.querySelector('.header__search-input');
const headerChild = document.querySelectorAll('.header__nav-child');
const menuItem = document.querySelectorAll('.js-nav-link');
const menuItemSp = document.querySelectorAll('.js-nav-link-sp');
const headerChildBg = document.querySelector('.header__nav-child-bg');
const headerChildBgOverflow = document.querySelector('.header__nav-child-bg-overflow');
const headerSearchChildBgOverflow = document.querySelector('.header__search-child-bg-overflow');
const blur = document.querySelector('.header__blur-wrap');
const openBtn = document.querySelector('.header__utility--open');
const closeBtn = document.querySelector('.header__utility--close');
const mediaQueryList = window.matchMedia('(min-width: 1279px)');
const mediaQueryListPc = window.matchMedia('(min-width: 959px) and (max-width: 1278px)');
const mediaQueryListSp = window.matchMedia('(max-width: 958px)');
const focusableElementsString = 'a[href], area[href], input:not([disabled]), button:not([disabled]), object, embed, [tabindex="0"], [contenteditable]';

let headerH;
let windowState;
let tabIndexNum;
let windowHeight = window.innerHeight;
let focusedElementBeforeModal;

function pageLoad() {
  window.onload = function () {
    main.classList.remove('load-fade');
  };
  const linkEls = [...document.querySelectorAll('a:not([href*="#"]):not([target])')];
  const currentHostName = window.location.hostname;
  //URL内のみ条件にする
  function addFadeOut(url) {
    main.classList.add('load-fade');
    setTimeout(() => {
      window.location = url;
    }, 800);
  }
  // setTimeoutのdelay mainのtransitionと合わせる
  linkEls.forEach((linkEl) => {
    linkEl.addEventListener(
      'click',
      (e) => {
        // command or control+クリックのときは処理しない / SPのドロップダウン除外 - linkEls
        if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey) || linkEls) return;
        e.preventDefault();
        e.stopPropagation();
        let url = linkEl.getAttribute('href');
        if (url !== '' && url == '/' && url.indexOf(currentHostName)) {
          addFadeOut(url);
        }
      },
      false
    );
  });
  // SafariでブラウザバックするとJSなどが解除されていない問題【bfcache】の対策
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      // bfcache発動時の処理
      window.location.reload();
    }
  });
}

function headerLinkCurrent() {
  var currentURL = location.href.split('/');
  var currentURL2 = currentURL[3].split('?')[0]; // ?以降を削除してからURLを取得

  headerLink.forEach((targetLink) => {
    let targertHref = targetLink.getAttribute('href');
    let targertHref2 = targertHref.replace(/(\\|\/)/g, '');

    if (targertHref2 === currentURL2) {
      targetLink.classList.add('--current');
      targetLink.classList.add('--btn-unactivate');
    }
  });
}

function state() {
  if (mediaQueryList.matches) {
    windowState = 'PC';
    headerH = header.clientHeight;
    tabIndexNum = '-1';
  } else if (mediaQueryListPc.matches) {
    windowState = 'SP';
    headerH = header.clientHeight;
    tabIndexNum = '0';
  } else {
    windowState = 'SM';
    headerH = header.clientHeight;
    tabIndexNum = '0';
  }
}

function changeWindowSize() {
  mediaQueryList.addEventListener('change', function (e) {
    if (e.matches) {
      windowState = 'PC';
      headerH = header.clientHeight;
      tabIndexNum = '-1';
      initPc();
      setChildMenuPC();
      unfixWindow();
      if (searchTarget.classList.contains('is-search-target-open')) {
        openSearch();
        document.querySelector('.header__search-child').style.backgroundColor = '#FFF';
        document.querySelector('.header__search-child-absolute').style.backgroundColor = '#FFF';
        headerNav.style.opacity = 0;
        fixWindow();
      } else {
        document.querySelector('.header__search-child').style.backgroundColor = '';
        document.querySelector('.header__search-child-absolute').style.backgroundColor = '';
      }
    }
  });

  mediaQueryListPc.addEventListener('change', function (e) {
    if (e.matches) {
      windowState = 'SP';
      headerH = header.clientHeight;
      tabIndexNum = '0';
      initSp();
      setChildMenu();
    }
  });

  mediaQueryListSp.addEventListener('change', function (e) {
    if (e.matches) {
      windowState = 'SM';
      tabIndexNum = '0';
      initSp();
      setChildMenu();
    }
  });
}

function enterHeader() {
  const headerTrigger = document.querySelector('.header');
  // ドロップdownなしのリンク
  function onMouseLinksHasDrop() {
    for (let i = 0; i < headerLink.length; i++) {
      let item = headerLink[i];
      function onMouse(e) {
        if (windowState === 'PC') {
          if (item.classList.contains('js-nav-link') == false) {
            headerChildBg.style.height = headerH + 'px';
            headerChildBgOverflow.style.height = headerH + 'px';
          }
        }
      }
      item.addEventListener('mouseenter', onMouse, false);
    }
  }

  function onMouseHead(e) {
    if (windowState === 'PC') {
      if (header.classList.contains('is-header-search')) {
        return;
      } else if (header.classList.contains('is-sticky') === false) {
        headerChildBg.style.height = headerH + 'px';
        headerChildBgOverflow.style.height = headerH + 'px';
      }
    }
  }

  function onMouseHeadLeave(e) {
    if (windowState === 'PC') {
      if (header.classList.contains('is-header-search')) {
        return;
      } else {
        headerChildBg.style.height = 0 + 'px';
        headerChildBgOverflow.style.height = headerH + 'px';
      }
    }
  }
  headerTrigger.addEventListener('mouseenter', onMouseHead, false);
  headerTrigger.addEventListener('mouseenter', onMouseLinksHasDrop, false);
  headerTrigger.addEventListener('mouseleave', onMouseHeadLeave, false);
}

function initPc() {
  closeMenuSp();
  body.classList.remove('is-nav-open');
  header.classList.remove('is-header-active');
  headerMenu.classList.remove('is-not-shown');
}

function initSp() {
  if (header.classList.contains('is-overflow-scroll')) {
    header.classList.remove('is-overflow-scroll');
    unfixWindow();
  }
  if (searchTarget.classList.contains('is-search-target-open')) {
    burger.classList.add('is-fade');
  } else {
    burger.classList.remove('is-fade');
  }
}

function openMenuSp() {
  burger.classList.add('is-burger-open');
  headerMenu.classList.add('is-shown');
  headerMenu.classList.remove('is-not-shown');
  header.classList.add('is-header-active');
}

function closeMenuSp() {
  burger.classList.remove('is-burger-open');
  headerMenu.classList.remove('is-shown');
  headerMenu.classList.add('is-not-shown');
  header.classList.remove('is-header-active');
}

function fixWindow() {
  // 固定
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  body.classList.add('fixed');
  body.dataset.top = scrollTop;
  body.style.top = -scrollTop + 'px';
  html.style.overflowY = 'scroll';
}

function unfixWindow() {
  // 固定解除
  var scrollPos = document.querySelector('body').dataset.top;
  body.classList.remove('fixed');
  body.style.top = '';
  window.scrollTo({ top: scrollPos, behavior: 'instant' });
  html.style.overflowY = '';
}

function closeSearch() {
  openBtn.style.display = 'block';
  closeBtn.style.display = 'none';
  searchTarget.classList.remove('is-search-target-open');
  search.setAttribute('aria-expanded', 'false');
  searchTarget.setAttribute('aria-hidden', 'true');
  blur.classList.remove('is-blur-show');
  burger.classList.remove('is-fade');
  header.classList.remove('is-header-active');
  header.classList.remove('is-header-search');
  searchTargetWrapper.classList.remove('is-shown');
  searchTargetWrapper.classList.add('is-not-shown');
  header.style.zIndex = 'unset';
}

function openSearch() {
  openBtn.style.display = 'none';
  closeBtn.style.display = 'block';
  searchTarget.classList.add('is-search-target-open');
  search.setAttribute('aria-expanded', 'true');
  searchTarget.setAttribute('aria-hidden', 'false');
  blur.classList.add('is-blur-show');
  header.classList.add('is-header-active');
  header.classList.add('is-header-search');
  searchTargetWrapper.classList.add('is-shown');
  searchTargetWrapper.classList.remove('is-not-shown');
  header.style.zIndex = 100;
}

function setChildMenu() {
  const elementsH = document.getElementsByClassName('header__nav-link');
  body.classList.remove('is-nav-open');
  Array.prototype.forEach.call(headerChild, function (element) {
    element.classList.remove('is-dropdown-open');
    element.style.height = '0';
  });
  Array.prototype.forEach.call(elementsH, function (element) {
    element.classList.remove('is-child-open');
  });
}

function setChildMenuPC(e) {
  body.classList.remove('is-nav-open');
  Array.prototype.forEach.call(headerChild, function (element) {
    element.classList.remove('is-dropdown-open');
    element.style.height = '0';
    headerChildBg.style.height = '0';
    headerChildBgOverflow.style.height = '0';
  });
  Array.prototype.forEach.call(headerLink, function (element) {
    element.classList.remove('-hover');
  });
  if (header.classList.contains('is-overflow-scroll')) {
    header.classList.remove('is-overflow-scroll');
    unfixWindow();
  }
}

function globalNav() {
  function toggleSpMenu() {
    function burgerClick(e) {
      if (windowState === 'SP' || windowState === 'SM') {
        e.preventDefault();
        if (burger.classList.contains('is-burger-open')) {
          closeMenuSp();
          unfixWindow();
          let focusableElementsStringMain = main.querySelectorAll(focusableElementsString);
          let firstMainTabStop = focusableElementsStringMain[0];
          firstMainTabStop.focus({ preventScroll: true });
        } else {
          openMenuSp();
          headerNav.setAttribute('aria-hidden', 'false');
          fixWindow();
          if (searchTarget.classList.contains('is-search-target-open')) {
            //検索開いている場合
            closeSearch();
          }
          const focusMenu = document.querySelector('.header');
          setTimeout(() => {
            focusMenu.focus();
          }, 500);
          const trapTabKeyMenuSp = (e) => {
            let naviFocusableElements = focusMenu.querySelectorAll(focusableElementsString);
            let firstTabStop = naviFocusableElements[0];
            let lastTabStop = naviFocusableElements[naviFocusableElements.length - 1];
            if (e.keyCode === 9) {
              if (e.shiftKey) {
                if (document.activeElement === firstTabStop) {
                  e.preventDefault();
                  lastTabStop.focus();
                }
              } else {
                if (document.activeElement === lastTabStop) {
                  e.preventDefault();
                  firstTabStop.focus();
                }
              }
            }
            if (e.keyCode === 27) {
              closeMenuSp();
            }
          };
          focusMenu.addEventListener('keydown', trapTabKeyMenuSp);
        }
      }
    }
    burger.addEventListener('click', burgerClick, false);
  }
  toggleSpMenu();

  function spChildMenu() {
    for (let i = 0; i < menuItemSp.length; i++) {
      let item = menuItemSp[i];
      let dropMenu = item.nextElementSibling;
      function onClick(e) {
        if (windowState === 'SP' || windowState === 'SM') {
          e.preventDefault();
          if (item.classList.contains('is-child-open')) {
            this.classList.remove('is-child-open');
            dropMenu.classList.remove('is-dropdown-open');
            dropMenu.style.height = '0';
          } else {
            setChildMenu();
            this.classList.add('is-child-open');
            dropMenu.classList.add('is-dropdown-open');
            dropMenu.style.height = dropMenu.scrollHeight + 'px';
          }
        }
      }
      item.addEventListener('click', onClick, false);
    }
  }
  spChildMenu();

  function hoverMenuSet() {
    for (let i = 0; i < headerLink.length; i++) {
      let item = headerLink[i];

      function onMouse(e) {
        if (windowState === 'PC') {
          setChildMenuPC();
        }
      }
      item.addEventListener('mouseenter', onMouse, false);
    }
  }
  hoverMenuSet();

  function activateBtn() {
    for (let i = 0; i < menuItem.length; i++) {
      let item = menuItem[i];
      header.addEventListener('mousemove', function (e) {
        if (item.classList.contains('--btn-unactivate')) {
          item.classList.remove('--btn-unactivate');
        }
      });
    }
  }
  activateBtn();

  function hoverMenu() {
    for (let i = 0; i < menuItem.length; i++) {
      let item = menuItem[i];
      let dropMenu = item.nextElementSibling;
      function onMouse(e) {
        if (windowState === 'PC') {
          if (this.classList.contains('--btn-unactivate')) {
            return;
          } else {
            this.classList.remove('--btn-unactivate');
            this.classList.add('-hover');
            dropMenu.classList.add('is-dropdown-open');
            dropMenu.style.height = dropMenu.scrollHeight + 'px';
            headerChildBg.style.height = dropMenu.scrollHeight + 'px';
            headerChildBgOverflow.style.height = dropMenu.scrollHeight + 'px';
            headerChildBgOverflow.style.overflowY = '';
            body.classList.add('is-nav-open');
          }
        }
        if (windowState === 'PC') {
          if (dropMenu.scrollHeight >= windowHeight) {
            // ヘッダーがfixedになっているとき
            if (header.classList.contains('is-sticky') || header.classList.contains('header--lowerpage')) {
              // fixWindow();
              header.classList.add('is-overflow-scroll');
              setTimeout(function () {
                headerChildBgOverflow.style.overflowY = 'visible';
              }, 500); // 見切れ防止のため遅延
            }
          }
        }
      }
      item.addEventListener('mouseenter', onMouse, false);
    }
  }
  hoverMenu();

  function hoverMenuOut() {
    for (let i = 0; i < headerChild.length; i++) {
      let item = headerChild[i];
      let parentMenu = item.previousElementSibling;
      function onMouse(e) {
        if (windowState === 'PC') {
          if (searchTarget.classList.contains('is-search-target-open')) {
            return;
          } else if (header.classList.contains('is-overflow-scroll')) {
            item.classList.remove('is-dropdown-open');
            item.style.height = 0;
            parentMenu.classList.remove('-hover');
            body.classList.remove('is-nav-open');
            headerChildBg.style.height = '0';
            headerChildBgOverflow.style.height = '0';
            header.classList.remove('is-overflow-scroll');
            headerChildBgOverflow.style.overflowY = '';
            unfixWindow();
          } else {
            item.classList.remove('is-dropdown-open');
            item.style.height = 0;
            parentMenu.classList.remove('-hover');
            body.classList.remove('is-nav-open');
            headerChildBgOverflow.style.height = '0';
            headerChildBg.style.height = '0';
            headerChildBgOverflow.style.overflowY = '';
          }
        }
      }
      header.addEventListener('mouseleave', onMouse, false);
    }
  }
  hoverMenuOut();

  function trapKeySearch(e) {
    let focusableElements = searchTarget.querySelectorAll(focusableElementsString);
    let firstTabStop = focusableElements[0];
    let lastTabStop = focusableElements[focusableElements.length - 1];
    if (e.keyCode === 9) {
      if (e.shiftKey) {
        if (document.activeElement === lastTabStop) {
          e.preventDefault();
          lastTabStop.focus();
        }
      } else {
        if (document.activeElement === lastTabStop) {
          e.preventDefault();
          firstTabStop.focus();
        }
      }
    }
    if (e.keyCode === 27) {
      headerChildBg.style.paddingTop = '0';
      headerChildBg.style.height = '0';
      headerSearchChildBgOverflow.style.height = '0';
      headerNav.style.opacity = 1;
      headerChildBgOverflow.style.height = '0';
      document.querySelector('.header__search-child').style.backgroundColor = '';
      document.querySelector('.header__search-child-absolute').style.backgroundColor = '';
      closeSearch();
      // searchTarget.style.height = 0;
      unfixWindow();
    }
  }

  // searchTargetの高さの変更に背景を合わせる
  function searchTargetAdjustHeight() {
    if (windowState === 'PC') {
      if (searchTarget.classList.contains('is-search-target-open') == false) {
        return;
      } else {
        headerChildBg.style.height = headerH + searchTarget.scrollHeight + 'px';
        headerSearchChildBgOverflow.style.height = searchTarget.scrollHeight + 'px';
      }
    }
  }
  const observer = new MutationObserver(searchTargetAdjustHeight);
  const config = { attributes: true, childList: true, subtree: true };
  observer.observe(searchTarget, config);

  function searchMenu() {
    function searchBtnClick(e) {
      e.preventDefault();
      if (windowState === 'PC') {
        if (searchTarget.classList.contains('is-search-target-open') == false) {
          openSearch();
          setChildMenuPC();
          headerNav.style.opacity = 0;
          headerChildBgOverflow.style.height = '0';
          setTimeout(() => {
            searchInput.focus();
          }, 700);
          searchTarget.addEventListener('keydown', trapKeySearch);
          fixWindow();
        } else {
          // 閉じる処理
          headerChildBg.style.paddingTop = '0';
          headerChildBg.style.height = headerH + 'px';
          headerSearchChildBgOverflow.style.height = '0';
          headerNav.style.opacity = 1;
          headerChildBgOverflow.style.height = '0';
          document.querySelector('.header__search-child').style.backgroundColor = '';
          document.querySelector('.header__search-child-absolute').style.backgroundColor = '';
          closeSearch();
          unfixWindow();
        }
      }
    }
    searchBtn.addEventListener('click', searchBtnClick, false);
    searchBtnClose.addEventListener('click', searchBtnClick, false);

    // SPではダミーのinput要素を生成してinputにフォーカス
    function openSearchAndFocusInput() {
      openSearch();
      fixWindow();
      header.classList.add('is-header-active');
      burger.classList.add('is-fade');
      const fakeInput = document.createElement('input');
      fakeInput.setAttribute('type', 'text');
      fakeInput.style.position = 'absolute';
      fakeInput.style.opacity = 0;
      fakeInput.style.height = 0;
      fakeInput.style.fontSize = '16px'; // disable auto zoom
      document.body.prepend(fakeInput);
      fakeInput.focus();
      setTimeout(() => {
        searchInput.focus();
        fakeInput.remove();
      }, 500);
    }

    function searchBtnClickSP(e) {
      e.preventDefault();
      if (windowState === 'SP' || windowState === 'SM') {
        if (searchTarget.classList.contains('is-search-target-open') == false) {
          searchTarget.addEventListener('keydown', trapKeySearch);
          if (burger.classList.contains('is-burger-open')) {
            //バーガー展開している場合
            closeMenuSp();
          }
          openSearchAndFocusInput();
        } else {
          //検索閉じる
          closeSearch();
          setChildMenu();
          burger.classList.remove('is-fade');
          headerChildBg.style.paddingTop = '0';
          headerChildBg.style.height = '0';
          headerSearchChildBgOverflow.style.height = '0';
          headerNav.style.opacity = 1;
          headerChildBgOverflow.style.height = '0';
          unfixWindow();
        }
      }
    }

    searchBtn.addEventListener('click', searchBtnClickSP, false);
    searchBtnClose.addEventListener('click', searchBtnClickSP, false);

    function searchBgClick(e) {
      if (windowState === 'SP' || windowState === 'SM') {
        //検索閉じる SP
        burger.classList.remove('is-fade');
        document.querySelector('.header__search-child').style.backgroundColor = '';
        document.querySelector('.header__search-child-absolute').style.backgroundColor = '';
        closeSearch();
        setChildMenu();
        burger.classList.remove('is-fade');
        headerChildBg.style.paddingTop = '0';
        headerChildBg.style.height = '0';
        headerSearchChildBgOverflow.style.height = '0';
        headerNav.style.opacity = 1;
        headerChildBgOverflow.style.height = '0';
        headerLogo.classList.remove('active');
        unfixWindow();
      } else {
        headerNav.style.opacity = 1;
        closeSearch();
        // searchTarget.style.height = 0;
        document.querySelector('.header__search-child').style.backgroundColor = '';
        document.querySelector('.header__search-child-absolute').style.backgroundColor = '';
        headerChildBg.style.paddingTop = '0';
        headerChildBg.style.height = '0';
        headerSearchChildBgOverflow.style.height = '0';
        headerNav.style.opacity = 1;
        headerChildBgOverflow.style.height = '0';
        headerLogo.classList.remove('active');
        unfixWindow();
      }
    }

    blur.addEventListener('click', searchBgClick, false);
  }
  searchMenu();
}

function handleResize() {
  bgHeightSize();
}

function bgHeightSize() {
  if (windowState === 'PC') {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const height = entry.contentRect.height;
        if (height < 117) {
          headerChildBg.style.boxShadow = 'none';
        } else {
          headerChildBg.style.boxShadow = 'var(--shadow-2)';
        }
      }
    });
    observer.observe(headerChildBg);
  }
}

function fadePhoto() {
  // fade photo
  const pictureElements = document.querySelectorAll('picture:not(.no-fade)');
  const figureElements = document.querySelectorAll('figure');

  const options = {
    root: null,
    rootMargin: '-5% 0px',
    threshold: 0,
  };
  let observer = new IntersectionObserver(callback, options);
  pictureElements.forEach((pictureElement) => {
    observer.observe(pictureElement);
  });

  figureElements.forEach((figureElement) => {
    observer.observe(figureElement);
  });

  function callback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('load');
        observer.unobserve(entry.target);
      }
    });
  }
}

function fadeImages() {
  //contents fade
  const fadetargets = document.querySelectorAll('.js-fade');
  const fadetargets2 = document.querySelectorAll('.js-fade-only');
  const options = {
    root: null,
    rootMargin: '0px 0px',
    threshold: 0,
  };

  var perfEntries = performance.getEntriesByType('navigation');
  var type = null;
  perfEntries.forEach(function (pe) {
    // 読み込みタイプを取得
    type = pe.type;
  });

  // reloadの場合無し;
  if (type == 'reload') {
    fadetargets.forEach((fadetarget) => {
      fadetarget.classList.remove('js-fade');
    });
  }

  let observer = new IntersectionObserver(callback, options);
  fadetargets.forEach((fadetarget) => {
    observer.observe(fadetarget);
  });

  fadetargets2.forEach((fadetarget2) => {
    observer.observe(fadetarget2);
  });

  function callback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target);
      }
    });
  }
}

function blurRelatedLinkTitle() {
  const accordion = document.getElementsByClassName('js-related-accordion');
  for (let i = 0; i < accordion.length; i++) {
    let item = accordion[i];
    function tabINdexN(e) {
      item.tabIndex = tabIndexNum;
    }
    tabINdexN();
  }
  window.addEventListener('load', blurRelatedLinkTitle, false);
  window.addEventListener('resize', blurRelatedLinkTitle, false);
}

//related
function relatedClick() {
  const accordion = document.getElementsByClassName('js-related-accordion');
  for (let i = 0; i < accordion.length; i++) {
    let item = accordion[i];
    let parent = item.parentElement;
    let panel = parent.nextElementSibling;
    function onClick(e) {
      if ((windowState = 'SM')) {
        e.preventDefault();
        if (item.classList.contains('is-active')) {
          this.classList.remove('is-active');
          panel.classList.remove('is-dropdown-open');
          panel.style.height = '0';

          this.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          this.classList.add('is-active');
          panel.classList.add('is-dropdown-open');
          panel.style.height = panel.scrollHeight + 'px';
          this.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
        }
      }
    }
    item.addEventListener('click', onClick, false);
  }
}

function fromLeft() {
  //fromLeft
  const fadetargets = document.querySelectorAll('.js-show-from-left');
  const options = {
    root: null,
    rootMargin: '-5% 0px',
    threshold: 0,
  };
  let observer = new IntersectionObserver(callback, options);
  fadetargets.forEach((fadetarget) => {
    observer.observe(fadetarget);
  });

  function callback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('c-interaction-from-left');
        observer.unobserve(entry.target);
      }
    });
  }
}

function inputBtn() {
  const formBtn = document.querySelectorAll('.header__search-submit-wrap');
  const inputSearch = document.querySelectorAll('.search');
  const clearText = document.querySelectorAll('.clear-text');

  for (let i = 0; i < inputSearch.length; i++) {
    inputSearch[i].addEventListener('input', (event) => {
      event.target.nextElementSibling.classList.add('is-input');
    });
  }

  for (let i = 0; i < clearText.length; i++) {
    clearText[i].addEventListener('click', (event) => {
      event.target.previousElementSibling.classList.remove('is-input');
      event.target.closest('.header__search-input-wrap').querySelector('.search').value = '';
    });
  }
  //inputvalueが入っている場合
  for (let i = 0; i < inputSearch.length; i++) {
    if (inputSearch[i].value) {
      inputSearch[i].nextElementSibling.classList.add('is-input');
    }
  }
}

// // scroll page
document.querySelectorAll('a[href^="#"]:not(.js-modal-open)').forEach((anchor) => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const href = anchor.getAttribute('href');
    const target = document.getElementById(href.replace('#', ''));
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerH - 40;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  });
});

// page遷移 header分
function AccessAnchorLinkPositionAdjust(parameter = headerH + 80) {
  window.addEventListener('load', function () {
    const url = location.href;
    if (url.indexOf('#') !== -1) {
      const anchor = url.split('#');
      const href = '#' + anchor[anchor.length - 1];
      if (href.length > 0) {
        const targetElement = document.getElementById(href.replace('#', ''));
        const rect = targetElement.getBoundingClientRect().top;
        const offset = window.scrollY;
        const gap = parameter;
        const target = rect + offset - gap;
        window.scrollTo({
          top: target,
        });
      }
    }
  });
}

document.addEventListener(
  'DOMContentLoaded',
  function () {
    state();
    pageLoad();
    changeWindowSize();
    enterHeader();
    globalNav();
    fadePhoto();
    fadeImages();
    fromLeft();
    relatedClick();
    blurRelatedLinkTitle();
    headerLinkCurrent();
    inputBtn();
    AccessAnchorLinkPositionAdjust();
    handleResize();
    window.addEventListener('resize', handleResize);
  },
  false
);

// サイト内検索オートコンプリート
const nameList = ['Goldwin', 'ゴールドウイン', 'テック・ラボ', 'NEUTRALWORKS.', 'ニュートラルワークス.', 'PLAY EARTH KIDS', 'プレイアースキッズ', 'Speedo', 'スピード', 'ellesse', 'エレッセ', 'DANSKIN', 'ダンスキン', 'canterbury', 'カンタベリー', 'BLACK & WHITE', 'ブラック＆ホワイト', 'and per se', 'アンパスィ', 'THE NORTH FACE', 'ザ・ノース・フェイス', 'HELLY HANSEN', 'ヘリーハンセン', 'macpac', 'マックパック', 'icebreaker', 'アイスブレーカー', 'WOOLRICH', 'ウールリッチ', '241', 'トゥーフォーワン', 'FISCHER', 'フィッシャー', 'SUNSKI', 'サンスキー', 'PROFECIO', 'プロフェシオ', 'Allbirds', 'オールバーズ', 'Spiber', 'スパイバー', 'MOON PARKA', 'ムーンパーカ'];

const autoCompleteJS = new autoComplete({
  name: 'autoComplete',
  selector: '.search',
  wrapper: false,
  data: {
    src: nameList,
    cache: true,
  },
  trigger: (query) => {
    return query.replace(/ /g, '').length > 0; // スペースを無視する
  },
  query: (input) => {
    return input.replace('techlab', 'テック・ラボ');
  },
  threshold: 3,
  debounce: 300, // Milliseconds value
  searchEngine: 'loose',
  diacritics: true,
  submit: true,
  events: {
    input: {
      selection: (event) => {
        const selection = event.detail.selection.value;
        autoCompleteJS.input.value = selection;
      },
    },
  },
  resultsList: {
    tag: 'ul',
    id: 'autoComplete_suggestList',
    class: 'suggest',
    destination: '.header__search-suggest-wrap',
    position: 'afterbegin',
    tabSelect: true,
    maxResults: 4,
    noResults: true,
  },
});
